export const currencyOptions = [
  {value: 'CHF', label: 'CHF'},
  {value: 'CZK', label: 'CZK'},
  {value: 'EUR', label: 'EUR'},
  {value: 'GBP', label: 'GBP'},
  {value: 'PLN', label: 'PLN'},
  {value: 'RON', label: 'RON'},
  {value: 'USD', label: 'USD'},
];
